import { render } from "./CourseDetails.vue?vue&type=template&id=6b305b6a&ts=true"
import script from "./CourseDetails.vue?vue&type=script&lang=ts"
export * from "./CourseDetails.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Users\\iflam\\OneDrive\\নথিসমূহ\\tms-next\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__